/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FestnetznummerInputs */

const de__field_festnetznummer = /** @type {(inputs: _Field_FestnetznummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festnetznummer`)
};

/**

* @param {_Field_FestnetznummerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_festnetznummer = /** @type {((inputs?: _Field_FestnetznummerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FestnetznummerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_festnetznummer(inputs)
});